import { Checkbox } from "@material-ui/core";
import { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useFooterData } from "../../provider/billingProviders/footerDataProvider";

const DeliverAddressModal = ({ open = false, onClose = () => {} }) => {
  const [addressCheckBox, setAddressCheckBox] = useState(false);
  const dispatch = useDispatch();
  const [billShipAddress, setBillShipAddress] = useState({
    billingAddress: "",
    shippingAddress: "",
  });
  const { footerData, setFooterData } = useFooterData();

  useEffect(() => {
    setBillShipAddress((prev) => ({
      ...prev,
      billingAddress: footerData.billingAddress,
      shippingAddress: footerData.shippingAddress,
    }));
    if (footerData.shippingAddress && footerData.billingAddress) {
      const stringifyBillingAddress = JSON.stringify(footerData.billingAddress);
      const stringifyShippingAddress = JSON.stringify(
        footerData.shippingAddress
      );
      if (stringifyBillingAddress === stringifyShippingAddress) {
        setAddressCheckBox(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [footerData.shippingAddress, footerData.billingAddress]);

  return (
    <Modal
      show={open}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={() => onClose()}
    >
      <Modal.Header>
        <div>
          <h4 style={{ color: "#EF4667", marginBottom: 0 }}>
            Delivery Address
          </h4>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-6" style={{ paddingRight: 7 }}>
            <p>Billing Address</p>
            <Form.Control
              as="textarea"
              rows={5}
              value={billShipAddress.billingAddress}
              placeholder="Enter billing address"
              onChange={(e) => {
                if (addressCheckBox) {
                  setBillShipAddress({
                    ...billShipAddress,
                    billingAddress: e.target.value,
                    shippingAddress: e.target.value,
                  });
                  return;
                }
                setBillShipAddress((prev) => ({
                  ...prev,
                  billingAddress: e.target.value,
                }));
              }}
            />
          </div>
          <div className="col-6" style={{ paddingLeft: 7 }}>
            <p>Shipping Address</p>
            <Form.Control
              as="textarea"
              rows={5}
              placeholder="Enter shipping address"
              value={billShipAddress.shippingAddress}
              disabled={addressCheckBox}
              onChange={(e) => {
                setBillShipAddress((prev) => ({
                  ...prev,
                  shippingAddress: e.target.value,
                }));
              }}
            />
            <Checkbox
              checked={addressCheckBox}
              onChange={() => {
                setBillShipAddress((prev) => ({
                  ...prev,
                  shippingAddress: billShipAddress.billingAddress,
                }));
                setAddressCheckBox(!addressCheckBox);
              }}
            />
            <p
              style={{
                display: "inline-block",
                marginBottom: 0,
                fontSize: 14,
              }}
            >
              Same as Billing Address
            </p>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="cancelButton"
          onClick={() => {
            onClose();
          }}
        >
          Cancel
        </button>
        <button
          className="addAddrButton"
          onClick={() => {
            onClose();
            setFooterData((prev) => ({
              ...prev,
              billingAddress: billShipAddress.billingAddress,
              shippingAddress: billShipAddress.shippingAddress,
            }));
          }}
        >
          ADD ADDRESS
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeliverAddressModal;
